const API_URL = process.env.GATSBY_API_URL;

export const fabricJsonAssetsService = {
  createPresignedUploads,
  uploadToS3,
};

async function safeReadError(response) {
  try {
    const contentType = response.headers?.get?.('content-type') || '';
    if (contentType.includes('application/json')) {
      const body = await response.json();
      return body?.message || body?.error || JSON.stringify(body);
    }
    return await response.text();
  } catch (error) {
    return null;
  }
}

async function createPresignedUploads(payload = {}) {
  if (!API_URL) {
    throw new Error('API endpoint is not configured');
  }

  const response = await fetch(`${API_URL}/lineitem/fabric-json/presign`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const message = await safeReadError(response);
    throw new Error(message || `Failed to initialize Fabric JSON upload (${response.status})`);
  }

  return response.json();
}

async function uploadToS3(uploadDescriptor, blob, fileName) {
  if (!uploadDescriptor?.url) {
    throw new Error('Missing Fabric JSON upload target');
  }
  if (!blob) {
    throw new Error('Fabric JSON upload blob is required');
  }

  const formData = new FormData();
  const fields = uploadDescriptor.fields || {};
  Object.keys(fields).forEach(key => {
    formData.append(key, fields[key]);
  });
  formData.append('file', blob, fileName || 'fabric-json.txt');

  const response = await fetch(uploadDescriptor.url, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok && response.status !== 204) {
    const message = await safeReadError(response);
    throw new Error(message || `Fabric JSON S3 upload failed (${response.status})`);
  }
}
